import React from "react";

// import "./App.css";
// import React from 'react';
import { useState, useEffect } from "react";
import axios from "axios";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Register from "./register";
import Logged from "./logged";

// axios.defaults.xsrfCookieName = "csrftoken";
// axios.defaults.xsrfHeaderName = "X-CSRFToken";
// axios.defaults.withCredentials = true;

const client = axios.create({
    baseURL: "http://tagard.in:8005",
    withCredentials: true,
});

function Home() {
    const [currentUser, setCurrentUser] = useState();
    const [registrationToggle, setRegistrationToggle] = useState(false);
    const [email, setEmail] = useState("");
    // const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    useEffect(() => {
        client
            .get("/usr/user")
            .then(function (res) {
                window.localStorage.setItem("id", res.data["user"]);
                setCurrentUser(true);
            })
            .catch(function (error) {
                setCurrentUser(false);
            });
    }, [currentUser]);

    function update_form_btn() {
        if (registrationToggle) {
            document.getElementById("form_btn").innerHTML = "Register";
            setRegistrationToggle(false);
        } else {
            document.getElementById("form_btn").innerHTML = "Log in";
            setRegistrationToggle(true);
        }
    }

    // function submitRegistration(e) {
    //     e.preventDefault();
    //     client
    //         .post("/usr/register", {
    //             email: email,
    //             username: username,
    //             password: password,
    //         })
    //         .then(function (res) {
    //             client
    //                 .post("/usr/login", {
    //                     email: email,
    //                     password: password,
    //                 })
    //                 .then(function (res) {
    //                     setCurrentUser(true);
    //                 });
    //         });
    // }

    function submitLogin(e) {
        e.preventDefault();
        client
            .post("/usr/login", {
                email: email,
                password: password,
            })
            .then((res) => {
                // const cookies = res.headers["Set-Cookie"];

                const cookies = document.cookie;
                // console.log(JSON.stringify(cookies).split("csrftoken="));
                window.localStorage.setItem(
                    "token",
                    JSON.stringify(cookies).split("csrftoken=")[1]
                );
                // window.localStorage.setItem(
                //     "token",
                //     "EW93c23J7VgOEcbHayZKGymH29vnTezY"
                // );

                setCurrentUser(true);
                window.localStorage.setItem("loggedin", true);
            });
    }

    function submitLogout(e) {
        e.preventDefault();
        client
            .post("/usr/logout", { withCredentials: true })
            .then(function (res) {
                setCurrentUser(false);
                window.localStorage.removeItem("loggedin");
                window.localStorage.removeItem("id");
                window.localStorage.removeItem("token");
            });
    }

    if (currentUser) {
        return (
            <div>
                <Navbar bg="dark" variant="dark">
                    <Container>
                        <Navbar.Brand>TAG App</Navbar.Brand>
                        <Navbar.Toggle />
                        <Navbar.Collapse className="justify-content-end">
                            <Navbar.Text>
                                <form onSubmit={(e) => submitLogout(e)}>
                                    <Button type="submit" variant="light">
                                        Log out
                                    </Button>
                                </form>
                            </Navbar.Text>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
                <div className="center">
                    <Logged></Logged>
                </div>
            </div>
        );
    }
    return (
        <div>
            <Navbar bg="dark" variant="dark">
                <Container>
                    <Navbar.Brand>TAG App</Navbar.Brand>
                    <Navbar.Toggle />
                    <Navbar.Collapse className="justify-content-end">
                        <Navbar.Text>
                            <Button
                                id="form_btn"
                                onClick={update_form_btn}
                                variant="light"
                            >
                                Register
                            </Button>
                        </Navbar.Text>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            {registrationToggle ? (
                <Register></Register>
            ) : (
                <div className="center">
                    <Form onSubmit={(e) => submitLogin(e)}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Email address</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Enter email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <Form.Text className="text-muted">
                                We'll never share your email with anyone else.
                            </Form.Text>
                        </Form.Group>
                        <Form.Group
                            className="mb-3"
                            controlId="formBasicPassword"
                        >
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Form>
                </div>
            )}
        </div>
    );
}

export default Home;
